import api from './api';

export interface User {
  id: string;
  email: string;
  username: string;
  profile: {
    firstName?: string;
    lastName?: string;
  };
  gamification: {
    level: number;
    xp: number;
    hearts: number;
    streak: number;
  };
  onboarding: {
    completed: boolean;
    startedWith?: string;
    step?: number;
  };
  farms?: any[];
  gardens?: any[];
  spaces?: any[];
  plants?: any[];
}

export interface LoginData {
  email: string;
  password: string;
}

export interface RegisterData extends LoginData {
  username: string;
  firstName?: string;
  lastName?: string;
}

class AuthService {
  async login(data: LoginData) {
    const response = await api.post('/auth/login', data);
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    return user;
  }

  async register(data: RegisterData) {
    const response = await api.post('/auth/register', data);
    const { token, user } = response.data;
    localStorage.setItem('token', token);
    return user;
  }

  async getMe(): Promise<User> {
    const response = await api.get('/auth/me');
    return response.data;
  }

  logout() {
    localStorage.removeItem('token');
  }

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  setToken(token: string): void {
    localStorage.setItem('token', token);
  }
}

const authService = new AuthService();
export default authService;